import { Link } from "react-router-dom";
import { LOGO_URL } from "../lib/api";
import Seo from "../components/Seo";

export default function About() {
  return (
    <div className="bg-stone-50 min-h-screen" data-testid="about-page">
      <Seo
        title="About"
        description="Gens Realty, LLC is a boutique residential real estate brokerage serving Houston, Texas since 2010. Quiet luxury, hyperlocal expertise, honest counsel."
        path="/about"
      />
      <section className="max-w-5xl mx-auto px-6 lg:px-12 pt-20 pb-16">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-8 h-px bg-[#C9A961]" />
          <div className="eyebrow text-[#0A0A0A]">About Gens Realty</div>
        </div>
        <h1 className="font-display text-6xl lg:text-8xl leading-[0.92] tracking-tight text-[#0A0A0A] font-light">
          Boutique by design. <br />Houston <span className="serif-italic text-[#E63946]">to the core.</span>
        </h1>
      </section>

      <section className="max-w-5xl mx-auto px-6 lg:px-10 pb-16 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-8 space-y-6 text-[#333] leading-relaxed text-lg">
          <p>
            Gens Realty was founded on a simple idea: real estate should feel personal, transparent, and a little bit special. We're not a 500-agent franchise. We're a small bench of senior agents who only work with clients we can serve well — across every Houston-area neighborhood we know intimately.
          </p>
          <p>
            From a first-time buyer in Midtown to a luxury seller in River Oaks, we bring the same playbook: deep market knowledge, cinematic marketing, candid counsel, and a phone line that's actually answered.
          </p>
          <p>
            We're licensed in Texas (TREC #9001234) and based in Uptown Houston, but our work spans the Inner Loop to The Woodlands, Sugar Land to Katy. If it's residential and it's Houston — we know it.
          </p>
        </div>
        <aside className="lg:col-span-4 bg-white border border-gray-200 rounded-2xl p-8 self-start">
          <img src={LOGO_URL} alt="Gens Realty" className="h-20 w-20 object-contain mb-5" />
          <div className="font-display text-2xl font-semibold">Gens Realty, LLC</div>
          <div className="text-sm text-gray-500 mt-1">Residential brokerage · est. 2010</div>
          <div className="mt-5 pt-5 border-t border-gray-200 text-sm text-[#555] space-y-2">
            <div>14911 Heritage Wood Drive</div>
            <div>Houston, TX 77082</div>
            <div className="pt-3 text-[#1A1A1A] font-medium">(832) 741-4662</div>
            <div className="text-[#1A1A1A] font-medium">PJoseph@gensrealty.com</div>
          </div>
        </aside>
      </section>

      <section className="bg-[#1A1A1A] text-white">
        <div className="max-w-5xl mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-3 gap-10">
          <Pillar n="01" title="Local lens">
            We've lived, worked, and raised families in the neighborhoods we sell. That's not marketing — it's the job.
          </Pillar>
          <Pillar n="02" title="Quiet luxury">
            Service that feels considered, not flashy. The right details, in the right places, delivered without fanfare.
          </Pillar>
          <Pillar n="03" title="Fewer, better">
            We take fewer clients on purpose. It's how we keep responses fast, judgement sharp, and outcomes consistently great.
          </Pillar>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 lg:px-10 py-20 text-center">
        <h2 className="font-display text-4xl lg:text-5xl font-light tracking-tighter">
          Talk to a Houston specialist.
        </h2>
        <Link
          to="/contact"
          className="inline-block mt-6 bg-[#E63946] hover:bg-[#c9313d] text-white px-7 py-3.5 rounded-md font-semibold text-sm transition-colors"
          data-testid="about-cta"
        >
          Schedule a consultation
        </Link>
      </section>
    </div>
  );
}

function Pillar({ n, title, children }) {
  return (
    <div>
      <div className="text-[10px] uppercase tracking-[0.3em] text-[#E63946]">{n}</div>
      <h3 className="font-display text-2xl font-semibold mt-3">{title}</h3>
      <p className="text-sm text-white/75 leading-relaxed mt-3">{children}</p>
    </div>
  );
}
